import _ from 'lodash';

import { APPRAISAL_CARD_MARKER_GROUP_KEYS } from './Appraisal.config';

export const buildAppraisalProductOptions = appraisalProducts =>
  appraisalProducts.map(({ id, name }) => ({ value: id, name }));

export const buildAppraisalSurchargeRows = loanAppraisalSurcharges =>
  loanAppraisalSurcharges.map(({ id, snapshotName, snapshotAmount }) => ({
    id,
    name: snapshotName,
    amount: snapshotAmount,
  }));

export const splitAppraisalConfigByCardMarkers = (groups = []) => {
  const markerIndexes = groups.reduce((acc, { key }, index) => {
    if (APPRAISAL_CARD_MARKER_GROUP_KEYS.includes(key)) {
      acc.push(index);
    }

    return acc;
  }, []);

  if (_.isEmpty(markerIndexes)) {
    return { firstRenderConfig: { groups: [] }, secondRenderConfig: { groups } };
  }

  return {
    firstRenderConfig: { groups: groups.slice(0, _.first(markerIndexes)) },
    secondRenderConfig: { groups: groups.slice(_.last(markerIndexes) + 1) },
  };
};
